"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var framer_motion_1 = require("framer-motion");
var CustomTruckSlide_1 = __importDefault(require("./CustomTruckSlide"));
var CustomTruckSection = function (_a) {
    var sections = _a.sections, index = _a.index, sectionRefs = _a.sectionRefs;
    var _b = (0, react_1.useState)(0), page = _b[0], setPage = _b[1];
    var paginate = function (direction) {
        setPage((0, framer_motion_1.wrap)(0, sections.length, page + direction));
    };
    var handleNext = function () { return paginate(1); };
    var handlePrev = function () { return paginate(-1); };
    var section = sections[page];
    return (react_1.default.createElement("article", null, section && (react_1.default.createElement(CustomTruckSlide_1.default, __assign({ ref: function (ref) {
            sectionRefs.current[index] = ref;
        } }, section, { activeIndex: page + 1, onNext: handleNext, onPrev: handlePrev })))));
};
exports.default = CustomTruckSection;
